// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b8c32a6a","239":"323255fb","455":"5e30572c","492":"92bdc1ce"}[chunkId] + ".chunk.js";
};